import React, { useState } from 'react';
const Header = ({ isDarkMode, onToggleDarkMode, isAdminAuthenticated, onAdminLogout, currentUser, onUserLogout, onShowAuth }) => {
  return (
    <header className={`border-b transition-colors duration-200 px-4 py-4 sticky top-0 z-[100] ${
      isDarkMode 
        ? 'bg-gray-800 border-gray-700' 
        : 'bg-white border-gray-200'
    }`}>
      <div className="max-w-6xl mx-auto flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="w-8 h-8 md:w-10 md:h-10 bg-gradient-to-br from-green-500 to-blue-600 rounded-lg flex items-center justify-center">
            <span className="text-white font-bold text-sm md:text-lg">د</span>
          </div>
          <div>
            <h1 className={`text-lg md:text-2xl font-semibold ${
              isDarkMode ? 'text-white' : 'text-gray-800'
            }`}>
              Darija Translator
            </h1>
            <p className={`text-xs md:text-sm ${
              isDarkMode ? 'text-gray-300' : 'text-gray-600'
            }`}>
              Translate to Moroccan Arabic
            </p>
          </div>
        </div>
        
        <div className="flex items-center gap-2 md:gap-4">
          {/* Dark Mode Toggle */}
          <button
            onClick={onToggleDarkMode}
            className={`p-2 rounded-lg transition-colors ${
              isDarkMode 
                ? 'hover:bg-gray-700 text-gray-300' 
                : 'hover:bg-gray-100 text-gray-600'
            }`}
            aria-label="Toggle dark mode"
          >
            {isDarkMode ? (
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z" />
              </svg>
            ) : (
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z" />
              </svg>
            )}
          </button>
          
          {/* User Menu */}
          {currentUser ? (
            <div className="flex items-center gap-2">
              <span className={`text-xs px-2 py-1 rounded ${
                isDarkMode ? 'bg-blue-800 text-blue-200' : 'bg-blue-100 text-blue-800'
              }`}>
                {currentUser.full_name}
              </span>
              <button
                onClick={onUserLogout}
                className={`text-xs px-2 py-1 rounded transition-colors ${
                  isDarkMode 
                    ? 'bg-gray-700 text-gray-300 hover:bg-gray-600' 
                    : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                }`}
              >
                Logout
              </button>
            </div>
          ) : (
            <button
              onClick={onShowAuth}
              className={`text-sm px-3 py-1.5 rounded-lg font-medium transition-colors ${
                isDarkMode 
                  ? 'bg-blue-600 text-white hover:bg-blue-700' 
                  : 'bg-blue-600 text-white hover:bg-blue-700'
              }`}
            >
              Sign In
            </button>
          )}
          
          {/* Admin Status */}
          {isAdminAuthenticated && (
            <div className="flex items-center gap-2">
              <span className={`text-xs px-2 py-1 rounded ${
                isDarkMode ? 'bg-green-800 text-green-200' : 'bg-green-100 text-green-800'
              }`}>
                Admin
              </span>
              <button
                onClick={onAdminLogout}
                className={`text-xs px-2 py-1 rounded transition-colors ${
                  isDarkMode 
                    ? 'bg-gray-700 text-gray-300 hover:bg-gray-600' 
                    : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                }`}
              >
                Logout
              </button>
            </div>
          )}
          
        </div>
      </div>
    </header>
  );
};


export default Header;
